export default "__VITE_ASSET__DnF8Q8mo__"